import type { Check } from "../checks.js";
import type { StructuralDecorator } from "../decorator.js";
import type { ItemKeyOf, ModulesOf, ResponseOf, TypedBy } from "../typedBy.js";

/**
 * A decorator adding a check to one item, after any it already has, typed by
 * what that item's response is.
 *
 * The modules are read only for their types, which `ResponseOf` reads.
 */
export const checkOf = <
  Typing extends TypedBy,
  Key extends ItemKeyOf<ModulesOf<Typing>>,
>(
  _typedBy: Typing,
  item: Key,
  check: Check<ResponseOf<ModulesOf<Typing>, Key>>,
): StructuralDecorator => ({
  kind: "structural",
  item: (view) =>
    view.at.item === item
      ? {
          ...view,
          // The stored schema may drop the instrument's refinements, but never
          // accepts a value outside this key's response type.
          checks: [...view.checks, check as Check<unknown>],
        }
      : view,
});
